// Webpack CSS import
import 'onsenui/css/onsenui.css'
import 'onsenui/css/onsen-css-components.css'


// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import './permission' // permission control
import VueOnsen from 'vue-onsenui' // This imports 'onsenui', so no need to import it separately
import VueCordova from 'vue-cordova'
import VueAnalytics from 'vue-analytics';
import VueCurrencyFilter from 'vue-currency-filter'


Vue.use(VueOnsen) // VueOnsen set here as plugin to VUE. Done automatically if a call to window.Vue exists in the startup code.
Vue.config.productionTip = false
Vue.use(VueCordova)

// Configuration VueAnalytics
Vue.use(VueAnalytics, {
  id: 'UA-157507967-4',
  router
});

Vue.use(VueCurrencyFilter, {
  symbol: '',
  thousandsSeparator: '.',
  fractionCount: 0,
  fractionSeparator: ',',
  symbolPosition: 'front',
  symbolSpacing: false
})

// console.log(Vue.cordova);

// add cordova.js only if serving the app through file://
if (window.location.protocol === 'file:' || window.location.port === '8181') {
  // var cordovaScript = document.createElement('script')
  // cordovaScript.setAttribute('type', 'text/javascript')
  // cordovaScript.setAttribute('src', '../cordova.js')
  // document.body.appendChild(cordovaScript)
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  data: function () {
    return {
      cordova: Vue.cordova
    }
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js